const InputFieldForm = ({
  label,
  name,
  type = "text",
  placeholder = "",
  value,
  onChange,
  onBlur,
  error,
  touched,
  height,
  width,
  readOnly = false,
  required = false,
  ...inputProps
}) => {
  return (
    <div className="flex flex-col gap-0.5 w-full">

      {label && (
        <label htmlFor={name} className="child-text font-medium">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
        style={{ height, width }}
        className={`border rounded p-1 child-text w-full 
    ${readOnly ? "bg-gray-300 cursor-not-allowed" : ""} `}
        {...inputProps}
      />

      <div className="min-h-[7px]">
        {touched && error && (
          <span className="error-text">
            {error}
          </span>
        )}
      </div>

    </div>
  );
};

export default InputFieldForm;